// layouts/TeacherLayout.js
import React, { useEffect } from "react";
import TeacherSidebar from "../components/teacher/TeacherSidebar";
import TeacherBottomNav from "../components/teacher/TeacherBottomNav"; // optional
import { Outlet, useNavigate } from "react-router-dom";
import { auth } from "../firebase/firebaseConfig";
import { useLayout } from "../contexts/LayoutContext";

export default function TeacherLayout() {
  const navigate = useNavigate();
  const handleLogout = async () => {
    await auth.signOut();
    navigate("/login");
  };
  const { setIsFullWidth } = useLayout();
  useEffect(() => {
    setIsFullWidth(true);
    return () => setIsFullWidth(false);
  }, [setIsFullWidth]);

  return (
    <div className="role-theme-surface flex min-h-screen bg-bg text-text relative">
      {/* Sidebar: hidden on mobile, fixed on desktop */}
      <TeacherSidebar onLogout={handleLogout} />

      {/* Main content */}
      <div className="flex-1 flex flex-col min-h-screen p-2 md:p-6 md:ml-0 pb-20 md:pb-0 transition-all duration-200">
        <div className="w-full max-w-5xl mx-auto">
          <Outlet />
        </div>
      </div>

      {/* Bottom nav: only show on mobile */}
      <TeacherBottomNav />
    </div>
  );
}
